import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/scss/app.scss";
import "./registerServiceWorker";
import { Donuz } from "donuz-js/Donuz";
import SocialSharing from "vue-social-sharing";
import VuejsPaginate from "vuejs-paginate";
import "materialize";
import "@fortawesome/fontawesome-free"
import VueTheMask from 'vue-the-mask';
import VueSweetalert2 from 'vue-sweetalert2';

const config = require('../config.json')

if (location.protocol != 'https:' && (!location.href.includes('localhost')  
                                  &&  !location.href.includes('192.168'))) {
    location.protocol = 'https:';
}

Vue.component("paginate", VuejsPaginate);
Vue.use(SocialSharing);
Vue.use(VueTheMask);
Vue.use(VueSweetalert2);

Vue.config.productionTip = false;

Vue.mixin({
    data: function() {
        return {
            baseUrl: config.baseUrl,
        };
    },
    methods: {
        getAdmins: async function() {
            return await Donuz.estabelishment.getInfoStore();
        }
    }
});
new Vue({
    router,
    render: h => h(App)
}).$mount("#app");